<span class="td-wb-w8ben-form-tooltip__container">&nbsp;
  <td-wb-tooltip-button id="td-wb-w8ben-tooltip-button"
                        class="td-wb-w8ben-form-tooltip__link"
                        [tdWbOverlayToggle]="w8BenTooltipTemplate"
                        tooltipPosition="center-right"
                        tooltipSize="small"
                        [ariaLabel]="('tdWb.w8BenForm.modal.common.HELP' | tdWbTranslate)" />
</span>
<ng-template #w8BenTooltipTemplate>
  <td-wb-overlay class="td-wb-w8ben-form-tooltip__overlay">
    <ng-content />
  </td-wb-overlay>
</ng-template>
